
import { useState } from 'react';
import CreatorSidebar from '../../components/feature/CreatorSidebar';
import UploadModal from '../../components/feature/UploadModal';

interface Content {
  id: number;
  image: string;
  title: string;
  level: number;
  likes: number;
  comments: number;
  date: string;
}

export default function Contents() {
  const [contents] = useState<Content[]>([
    { id: 1, image: 'https://public.readdy.ai/ai/img_res/fe2b906fd01f32e2a417f9641d5d4993.jpg', title: '오늘의 일상 💕', level: 1, likes: 234, comments: 45, date: '2024-03-20' },
    { id: 2, image: 'https://readdy.ai/api/search-image?query=cute%20korean%20girl%20fashion%20photo%20soft%20pastel%20purple%20background%20aesthetic%20natural%20light%20portrait%20photography%20style&width=400&height=500&seq=content2&orientation=portrait', title: '새로운 의상 공개!', level: 3, likes: 456, comments: 89, date: '2024-03-19' },
    { id: 3, image: 'https://readdy.ai/api/search-image?query=beautiful%20korean%20girl%20makeup%20photo%20soft%20pastel%20blue%20background%20aesthetic%20natural%20light%20portrait%20photography%20style&width=400&height=500&seq=content3&orientation=portrait', title: '메이크업 튜토리얼', level: 2, likes: 567, comments: 123, date: '2024-03-18' },
    { id: 4, image: 'https://readdy.ai/api/search-image?query=cute%20korean%20girl%20casual%20photo%20soft%20pastel%20pink%20background%20aesthetic%20natural%20light%20portrait%20photography%20style&width=400&height=500&seq=content4&orientation=portrait', title: '팬들에게 💌', level: 5, likes: 890, comments: 234, date: '2024-03-17' },
    { id: 5, image: 'https://readdy.ai/api/search-image?query=beautiful%20korean%20girl%20outdoor%20photo%20soft%20pastel%20purple%20background%20aesthetic%20natural%20light%20portrait%20photography%20style&width=400&height=500&seq=content5&orientation=portrait', title: '봄나들이 🌸', level: 1, likes: 345, comments: 67, date: '2024-03-16' },
    { id: 6, image: 'https://readdy.ai/api/search-image?query=cute%20korean%20girl%20studio%20photo%20soft%20pastel%20blue%20background%20aesthetic%20natural%20light%20portrait%20photography%20style&width=400&height=500&seq=content6&orientation=portrait', title: '화보 촬영 비하인드', level: 4, likes: 678, comments: 145, date: '2024-03-15' },
  ]);

  const [selectedContent, setSelectedContent] = useState<Content | null>(null);
  const [showUploadModal, setShowUploadModal] = useState(false);

  const handleDelete = (id: number) => {
    if (confirm('정말 이 콘텐츠를 삭제하시겠습니까?')) {
      console.log('삭제:', id);
      alert('콘텐츠가 삭제되었습니다.');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-pink-50 to-purple-50">
      <CreatorSidebar onUploadClick={() => setShowUploadModal(true)} />
      
      <div className="lg:ml-64 p-4 lg:p-8">
        <div className="max-w-7xl mx-auto">
          {/* 헤더 */}
          <div className="mb-8 flex items-center justify-between flex-wrap gap-4">
            <div>
              <h1 className="text-3xl font-bold text-gray-800 mb-2">내 콘텐츠</h1>
              <p className="text-gray-600">총 {contents.length}개의 콘텐츠</p>
            </div>
            <button
              onClick={() => setShowUploadModal(true)}
              className="bg-gradient-to-r from-pink-500 to-purple-500 text-white px-6 py-3 rounded-xl font-semibold hover:from-pink-600 hover:to-purple-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-add-circle-line mr-2"></i>
              콘텐츠 업로드
            </button>
          </div>

          {/* 콘텐츠 그리드 */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {contents.map((content) => (
              <div key={content.id} className="bg-white/80 backdrop-blur-sm rounded-2xl overflow-hidden border border-pink-100 shadow-lg hover:shadow-xl transition-all group">
                {/* 이미지 */}
                <div className="relative aspect-[4/5] overflow-hidden">
                  <img
                    src={content.image}
                    alt={content.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  
                  {/* 수정/삭제 버튼 */}
                  <div className="absolute top-3 right-3 flex gap-2">
                    <button
                      onClick={() => setSelectedContent(content)}
                      className="w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white transition-all shadow-lg cursor-pointer"
                    >
                      <i className="ri-edit-line text-purple-600"></i>
                    </button>
                    <button
                      onClick={() => handleDelete(content.id)}
                      className="w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white transition-all shadow-lg cursor-pointer"
                    >
                      <i className="ri-delete-bin-line text-pink-600"></i>
                    </button>
                  </div>

                  {/* 레벨 배지 */}
                  <div className="absolute top-3 left-3">
                    <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-gradient-to-r from-pink-400 to-purple-400 text-white text-xs font-semibold">
                      <i className="ri-vip-crown-fill"></i>
                      레벨 {content.level}
                    </span>
                  </div>
                </div>

                {/* 정보 */}
                <div className="p-4">
                  <h3 className="font-bold text-gray-800 mb-2">{content.title}</h3>
                  <div className="flex items-center justify-between text-sm text-gray-600">
                    <div className="flex items-center gap-3">
                      <span className="flex items-center gap-1">
                        <i className="ri-heart-fill text-pink-500"></i>
                        {content.likes}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-chat-3-line text-purple-500"></i>
                        {content.comments}
                      </span>
                    </div>
                    <span>{content.date}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 수정 모달 */}
      {selectedContent && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex items-center justify-between rounded-t-3xl">
              <h2 className="text-2xl font-bold text-gray-800">콘텐츠 수정</h2>
              <button
                onClick={() => setSelectedContent(null)}
                className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center transition-all cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            <div className="p-6 space-y-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-3">제목</label>
                <input
                  type="text"
                  defaultValue={selectedContent.title}
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-pink-400 focus:ring-2 focus:ring-pink-200 outline-none transition-all text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-3">구독 레벨</label>
                <select
                  defaultValue={selectedContent.level}
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-pink-400 focus:ring-2 focus:ring-pink-200 outline-none transition-all text-sm cursor-pointer"
                >
                  <option value="1">레벨 1 - 무료</option>
                  <option value="2">레벨 2 - 5,000원</option>
                  <option value="3">레벨 3 - 10,000원</option>
                  <option value="4">레벨 4 - 20,000원</option>
                  <option value="5">레벨 5 - 50,000원</option>
                </select>
              </div>

              <div className="flex gap-3">
                <button
                  onClick={() => setSelectedContent(null)}
                  className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-xl font-semibold hover:bg-gray-300 transition-all whitespace-nowrap cursor-pointer"
                >
                  취소
                </button>
                <button
                  onClick={() => {
                    alert('수정되었습니다!');
                    setSelectedContent(null);
                  }}
                  className="flex-1 bg-gradient-to-r from-pink-500 to-purple-500 text-white py-3 rounded-xl font-semibold hover:from-pink-600 hover:to-purple-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  저장
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 업로드 모달 */}
      {showUploadModal && <UploadModal onClose={() => setShowUploadModal(false)} />}
    </div>
  );
}
